import type { IntegrationListingItem } from './listingQuery'

export function filterIntegrations(
  integrations: IntegrationListingItem[],
  searchQuery: string
): IntegrationListingItem[] {
  const trimmed = searchQuery.trim().toLowerCase()
  if (!trimmed) return integrations
  return integrations.filter(
    (integration) =>
      integration.name.toLowerCase().includes(trimmed) ||
      integration.articleDescription.toLowerCase().includes(trimmed)
  )
}
